import * as types from './mutation-types'
const mutations = {
  [types.SET_STATUS](state, status) {
    state.status = status
  },
  [types.SET_ISWEIXIN](state, isWeixin) {
    state.isWeiXin = isWeixin
  },
  [types.SET_USER](state, user) {
    state.user = user
  },
  [types.SET_FILTERS](state, f = []) {
    state.filters = f
  },
  [types.PUSH_FILTERS](state, f) {
    if (f) {
      state.filters.push(f)
    }
  },
  [types.SPLICE_FILTERS](state, { start, length, replace }) {
    if (replace) {
      // 替换
      state.filters.splice(start, length, replace)
    } else {
      // 删除
      state.filters.splice(start, length)
    }
  },
  [types.SET_NEED_LOGIN](state, needLogin) {
    state.needLogin = needLogin
  },
  [types.SET_DURATION](state, duration) {
    state.duration = duration
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js